module.exports = __webpack_public_path__ + "img/TradingView-icon15_vi.02d8c8fc.svg";